/**
 * The password rule, mirrored from the server.
 *
 * `backend/src/lib/password.ts` is the authority: it is what actually refuses a
 * weak password, and a client check is a courtesy that saves a round trip. The
 * courtesy is worth having, because "the server said no" after a form submit is
 * a worse way to learn a rule than seeing it beside the field.
 *
 * Mirrored deliberately rather than fetched. A rule this small changes about
 * once a year, and an endpoint to ask what the password rule is would be a
 * request on the critical path of every signup to save duplicating one regex.
 */
export const PASSWORD_MIN = 8;

const HAS_LETTER = /\p{L}/u;
const HAS_DIGIT = /\d/;

export function isAcceptablePassword(v: string): boolean {
  return v.length >= PASSWORD_MIN && HAS_LETTER.test(v) && HAS_DIGIT.test(v);
}
